import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppLayoutService } from '../../app-layout.service';
import { IHeaderAction } from '../../interfaces';

@Component({
  selector: 'app-header-actions-mobile',
  templateUrl: './header-actions-mobile.component.html',
  styleUrls: ['./header-actions-mobile.component.scss'],
})
export class HeaderActionsMobileComponent implements OnInit, OnDestroy {
  public actions: IHeaderAction[] = [];

  private isDestroy: ReplaySubject<boolean> = new ReplaySubject();

  constructor(private appLayoutService: AppLayoutService) {}

  public ngOnInit(): void {
    this.appLayoutService.headerActions$.pipe(takeUntil(this.isDestroy)).subscribe((actions) => (this.actions = actions));
  }

  public ngOnDestroy(): void {
    this.isDestroy.next(true);
    this.isDestroy.complete();
  }
}
